import base64 from "base-64"

function setSrcObject(stream, element, ignoreCreateObjectURL) {
    if ('createObjectURL' in URL && !ignoreCreateObjectURL) {
        try {
            element.src = URL.createObjectURL(stream);
        } catch (e) {
            setSrcObject(stream, element, true);

        }
    } else if ('srcObject' in element) {
        element.srcObject = stream;
    } else if ('mozSrcObject' in element) {
        element.mozSrcObject = stream;
    } else {
        alert('createObjectURL/srcObject both are not supported.');
    }
}

export default class SafariWorker {

    constructor(){
        this.WhammyRecorder.bind(this);
    }

    WhammyRecorder = (mediaStream, config) => {

        config = config || {};

        if (!config.frameInterval) {
            config.frameInterval = 10;
        }

        if (!config.disableLogs) {
            console.log('Using frames-interval:', config.frameInterval);
        }

        /**
         * This method records video.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.record();
         */
        this.record = function () {
            if (!config.width) {
                config.width = 320;
            }

            if (!config.height) {
                config.height = 240;
            }

            if (!config.video) {
                config.video = {
                    width: config.width,
                    height: config.height
                };
            }

            if (!config.canvas) {
                config.canvas = {
                    width: config.width,
                    height: config.height
                };
            }

            canvas.width = config.canvas.width || 320;
            canvas.height = config.canvas.height || 240;

            context = canvas.getContext('2d');

            // setting defaults
            if (config.video && config.video instanceof HTMLVideoElement) {
                video = config.video.cloneNode();

                if (config.initCallback) {
                    config.initCallback();
                }
            } else {
                video = document.createElement('video');

                setSrcObject(mediaStream, video);

                video.onloadedmetadata = function () { // "onloadedmetadata" may NOT work in FF?
                    if (config.initCallback) {
                        config.initCallback();
                    }
                };

                video.width = config.video.width;
                video.height = config.video.height;
            }

            video.muted = true;
            //video.play();

            video = config.video;
            console.log(video);

            lastTime = new Date().getTime();
            whammy = new this.Whammy.Video();

            if (!config.disableLogs) {
                console.log('canvas resolutions', canvas.width, '*', canvas.height);
                console.log('video width/height', video.width || canvas.width, '*', video.height || canvas.height);
            }

            drawFrames(config.frameInterval);
        };

        this.startRecording = this.record;

        /**
         * Draw and push frames to Whammy
         * @param {integer} frameInterval - set minimum interval (in milliseconds) between each time we push a frame to Whammy
         */
        function drawFrames(frameInterval) {
            frameInterval = typeof frameInterval !== 'undefined' ? frameInterval : 10;

            var duration = new Date().getTime() - lastTime;
            if (!duration) {
                return setTimeout(drawFrames, frameInterval, frameInterval);
            }

            if (isPausedRecording) {
                lastTime = new Date().getTime();
                return setTimeout(drawFrames, 100);
            }

            // via #206, by Jack i.e. @Seymourr
            lastTime = new Date().getTime();

            if (video.paused) {
                // via: https://github.com/muaz-khan/WebRTC-Experiment/pull/316
                // Tweak for Android Chrome
                //video.play();
            }

            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            whammy.frames.push({
                duration: duration,
                image: canvas.toDataURL('image/jpeg')
            });

            if (!isStopDrawing) {
                setTimeout(drawFrames, frameInterval, frameInterval);
            }
        }

        function asyncLoop(o) {
            var i = -1,
                length = o.length;

            (function loop() {
                i++;
                if (i === length) {
                    o.callback();
                    return;
                }

                // "setTimeout" added by Jim McLeod
                setTimeout(function () {
                    o.functionToLoop(loop, i);
                }, 1);
            })();
        }


        /**
         * remove black frames from the beginning to the specified frame
         * @param {Array} _frames - array of frames to be checked
         * @param {number} _framesToCheck - number of frame until check will be executed (-1 - will drop all frames until frame not matched will be found)
         * @param {number} _pixTolerance - 0 - very strict (only black pixel color) ; 1 - all
         * @param {number} _frameTolerance - 0 - very strict (only black frame color) ; 1 - all
         * @returns {Array} - array of frames
         */
        // pull#293 by @volodalexey
        function dropBlackFrames(_frames, _framesToCheck, _pixTolerance, _frameTolerance, callback) {
            var localCanvas = document.createElement('canvas');
            localCanvas.width = canvas.width;
            localCanvas.height = canvas.height;
            var context2d = localCanvas.getContext('2d');
            var resultFrames = [];

            var checkUntilNotBlack = _framesToCheck === -1;
            var endCheckFrame = (_framesToCheck && _framesToCheck > 0 && _framesToCheck <= _frames.length) ?
                _framesToCheck : _frames.length;
            var sampleColor = {
                r: 0,
                g: 0,
                b: 0
            };
            var maxColorDifference = Math.sqrt(
                Math.pow(255, 2) +
                Math.pow(255, 2) +
                Math.pow(255, 2)
            );
            var pixTolerance = _pixTolerance && _pixTolerance >= 0 && _pixTolerance <= 1 ? _pixTolerance : 0;
            var frameTolerance = _frameTolerance && _frameTolerance >= 0 && _frameTolerance <= 1 ? _frameTolerance : 0;
            var doNotCheckNext = false;

            asyncLoop({
                length: endCheckFrame,
                functionToLoop: function (loop, f) {
                    var matchPixCount, endPixCheck, maxPixCount;

                    var finishImage = function () {
                        if (!doNotCheckNext && maxPixCount - matchPixCount <= maxPixCount * frameTolerance) {
                            // console.log('removed black frame : ' + f + ' ; frame duration ' + _frames[f].duration);
                        } else {
                            // console.log('frame is passed : ' + f);
                            if (checkUntilNotBlack) {
                                doNotCheckNext = true;
                            }
                            resultFrames.push(_frames[f]);
                        }
                        loop();
                    };

                    if (!doNotCheckNext) {
                        var image = new Image();
                        image.onload = function () {
                            context2d.drawImage(image, 0, 0, canvas.width, canvas.height);
                            var imageData = context2d.getImageData(0, 0, canvas.width, canvas.height);
                            matchPixCount = 0;
                            endPixCheck = imageData.data.length;
                            maxPixCount = imageData.data.length / 4;

                            for (var pix = 0; pix < endPixCheck; pix += 4) {
                                var currentColor = {
                                    r: imageData.data[pix],
                                    g: imageData.data[pix + 1],
                                    b: imageData.data[pix + 2]
                                };
                                var colorDifference = Math.sqrt(
                                    Math.pow(currentColor.r - sampleColor.r, 2) +
                                    Math.pow(currentColor.g - sampleColor.g, 2) +
                                    Math.pow(currentColor.b - sampleColor.b, 2)
                                );
                                // difference in color it is difference in color vectors (r1,g1,b1) <=> (r2,g2,b2)
                                if (colorDifference <= maxColorDifference * pixTolerance) {
                                    matchPixCount++;
                                }
                            }
                            finishImage();
                        };
                        image.src = _frames[f].image;
                    } else {
                        finishImage();
                    }
                },
                callback: function () {
                    resultFrames = resultFrames.concat(_frames.slice(endCheckFrame));

                    if (resultFrames.length <= 0) {
                        // at least one last frame should be available for next manipulation
                        // if total duration of all frames will be < 1000 than ffmpeg doesn't work well...
                        resultFrames.push(_frames[_frames.length - 1]);
                    }
                    callback(resultFrames);
                }
            });
        }

        var isStopDrawing = false;

        /**
         * This method stops recording video.
         * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.stop(function(blob) {
     *     video.src = URL.createObjectURL(blob);
     * });
         */
        this.stop = function (callback) {
            callback = callback || function () {
            };

            isStopDrawing = true;

            var _this = this;

            whammy.compileSafari(function (blob) {
                _this.blob = blob;

                if (callback) {
                    callback(_this.blob);
                }
            });
            // // analyse of all frames takes some time!
            // setTimeout(function () {
            //     // e.g. dropBlackFrames(frames, 10, 1, 1) - will cut all 10 frames
            //     // e.g. dropBlackFrames(frames, 10, 0.5, 0.5) - will analyse 10 frames
            //     // e.g. dropBlackFrames(frames, 10) === dropBlackFrames(frames, 10, 0, 0) - will analyse 10 frames with strict black color
            //     dropBlackFrames(whammy.frames, -1, null, null, function (frames) {
            //         whammy.frames = frames;
            //
            //         // to display advertisement images!
            //         if (config.advertisement && config.advertisement.length) {
            //             whammy.frames = config.advertisement.concat(whammy.frames);
            //         }
            //
            //         /**
            //          * @property {Blob} blob - Recorded frames in video/webm blob.
            //          * @memberof WhammyRecorder
            //          * @example
            //          * recorder.stop(function() {
            //      *     var blob = recorder.blob;
            //      * });
            //          */
            //
            //     });
            // }, 10);
        };

        this.stopRecording = this.stop;

        var isPausedRecording = false;

        /**
         * This method pauses the recording process.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.pause();
         */
        this.pause = function () {
            isPausedRecording = true;
        };

        /**
         * This method resumes the recording process.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.resume();
         */
        this.resume = function () {
            isPausedRecording = false;

            if (isStopDrawing) {
                this.record();
            }
        };

        /**
         * This method resets currently recorded data.
         * @method
         * @memberof WhammyRecorder
         * @example
         * recorder.clearRecordedData();
         */
        this.clearRecordedData = function () {
            if (!isStopDrawing) {
                this.stop(clearRecordedDataCB);
            }
            clearRecordedDataCB();
        };

        function clearRecordedDataCB() {
            whammy.frames = [];
            isStopDrawing = true;
            isPausedRecording = false;
        }

        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');

        var video;
        var lastTime;
        var whammy;

        return this;
    };

// https://github.com/antimatter15/whammy/blob/master/LICENSE
// _________
// Whammy.js

// todo: Firefox now supports webp for webm containers!
// their MediaRecorder implementation works well!
// should we provide an option to record via Whammy.js or MediaRecorder API is a better solution?

    /**
     * Whammy is a standalone class used by {@link RecordRTC} to bring video recording in Chrome. It is written by {@link https://github.com/antimatter15|antimatter15}
     * @summary A real time javascript webm encoder based on a canvas hack.
     * @license {@link https://github.com/muaz-khan/RecordRTC#license|MIT}
     * @author {@link http://www.MuazKhan.com|Muaz Khan}
     * @typedef Whammy
     * @class
     * @example
     * var recorder = new Whammy().Video(15);
     * recorder.add(context || canvas || dataURL);
     * var output = recorder.compile();
     * @see {@link https://github.com/muaz-khan/RecordRTC|RecordRTC Source Code}
     */

    Whammy = (function () {
        // a more abstract-ish API

        function WhammyVideo(duration) {
            this.frames = [];
            this.duration = duration || 1;
            this.quality = 0.8;
        }

        /**
         * Pass Canvas or Context or image/webp(string) to {@link Whammy} encoder.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * recorder.add(canvas || context || 'image/webp');
         * @param {string} frame - Canvas || Context || image/webp
         * @param {number} duration - Stick a duration (in milliseconds)
         */
        WhammyVideo.prototype.add = function (frame, duration) {
            if ('canvas' in frame) { //CanvasRenderingContext2D
                frame = frame.canvas;
            }

            if ('toDataURL' in frame) {
                frame = frame.toDataURL('image/jpeg', this.quality);
            }

            if (!(/^data:image\/jpeg;base64,/ig).test(frame)) {
                throw 'Input must be formatted properly as a base64 encoded DataURI of type image/jpeg';
            }
            this.frames.push({
                image: frame,
                duration: duration || this.duration
            });
        };

        function processInWebWorker(_function) {
            var blob = URL.createObjectURL(new Blob([_function.toString(),
                'this.onmessage =  function (e) {' + _function.name + '(e.data);}'
            ], {
                type: 'application/javascript'
            }));

            var worker = new Worker(blob);
            URL.revokeObjectURL(blob);
            return worker;
        }

        function whammyInWebWorker(frames,noWorker) {
            return frames;
        }

        /**
         * Encodes frames in WebM container. It uses WebWorkinvoke to invoke 'ArrayToWebM' method.
         * @param {function} callback - Callback function, that is used to pass recorded blob back to the callee.
         * @method
         * @memberof Whammy
         * @example
         * recorder = new Whammy().Video(0.8, 100);
         * recorder.compile(function(blob) {
     *    // blob.size - blob.type
     * });
         */

        WhammyVideo.prototype.compileSafari = function (callback) {
            callback(whammyInWebWorker(this.frames,true));
        };

        WhammyVideo.prototype.compile = function (callback) {
            var webWorker = processInWebWorker(whammyInWebWorker);

            webWorker.onmessage = function (event) {
                if (event.data.error) {
                    console.error(event.data.error);
                    return;
                }
                callback(event.data);
            };

            webWorker.postMessage(this.frames);
        };

        return {
            /**
             * A more abstract-ish API.
             * @method
             * @memberof Whammy
             * @example
             * recorder = new Whammy().Video(0.8, 100);
             * @param {?number} speed - 0.8
             * @param {?number} quality - 100
             */
            Video: WhammyVideo
        };
    })();
}



// WEBPACK FOOTER //
// ./src/Shared/SafariWorker.js